<template>
    <div>
        <section class="section-shaped my-4 py-3" id="midias">
            <div class="container">
                <v-wait for="person.profile.load" transition="fade" :duration="750">
                    <template slot="waiting">
                        <div class="col">
                            <div class="ph-col-5 mt-3 mb-5"></div>
                            <div class="ph-container">
                            <div class="ph-col-7 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-4 mb-2"></div>
                            <div class="ph-col-7 mb-2"></div><div class="ph-col-1 empty mb-2"></div><div class="ph-col-4 mb-2"></div>
                            </div>
                        </div>
                    </template>
                    <h3 class="display-3 d-block mb-3" v-if="person.filmografia.length">Mídias</h3>
                    <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Ações da Sacola de Títulos" v-if="person.filmografia.length">
                        <div class="btn-group my-2" role="group" aria-label="First group">
                            <b-form-checkbox v-model="allSelected" @change="toggleAll" name="check-button" button button-variant="secondary" size="sm">
                            {{ allSelected ? 'Desmarcar Todas' : 'Marcas Todas' }}
                            </b-form-checkbox>
                        </div>
                        <div class="btn-group my-2" role="group" aria-label="First group">
                            <base-button type="primary" size="sm" class="d-inline-block float-right" :disabled="!selected.length" @click="addToCart(selected)">
                                Adicionar
                            </base-button>
                        </div>
                    </div>
                    <div v-if="person.filmografia.length">
                        <div class="table-responsive my-4" v-for="titulo in person.filmografia" :key="titulo.id">
                            <table class="table cart-table">
                                <thead>
                                    <tr>
                                        <th><router-link :to="makeRoute(titulo)"><img v-lazy="makeCover(titulo)" width="90" :title="`${titulo.titulo_traduzido} (${titulo.ano})`"></router-link></th>
                                        <th scope="row" colspan="6" class="titleName"><router-link :to="makeRoute(titulo)">{{titulo.titulo_traduzido}} ({{titulo.ano}})</router-link></th>
                                    </tr>
                                    <tr>
                                        <th scope="col" class="format">Qualidade</th>
                                        <th scope="col">Fonte</th>
                                        <th scope="col" class="text-center">Faixas de Áudio</th>
                                        <th scope="col" class="text-center">Dublagem Disponível</th>
                                        <th scope="col" class="text-center">Legendas</th>
                                        <th scope="col" class="text-center" v-if="titulo.seriado">Temporada</th>
                                        <th scope="col" class="text-center" v-if="titulo.seriado">Discos</th>
                                        <th scope="col" class="text-right">Cadastro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <template v-for="midia in titulo.midias">
                                <tr :key="midia.id" :class="[midia.preco ? 'gold' : '']">
                                    <th scope="row">
                                        <b-form-checkbox
                                            v-model="selected"
                                            :value="midia"
                                            name="midia.id"
                                            inline
                                        >
                                        <img width="20" height="20" :src="[midia.formato ? 'img/mediaformat/'+midia.formato+'.svg' : 'numtem']">
                                        {{midia.formato}}
                                        </b-form-checkbox>
                                    </th>
                                    <td><span class="badge badge-info">{{midia.origem}}</span></td>
                                    <td class="text-center"><span v-if="midia.audio" class="badge badge-success">{{midia.audio}}</span></td>
                                    <td class="text-center"><p v-if="midia.estudios_dublagem.length" v-html="midia.estudios_dublagem.join(' + ')"></p><p v-if="midia.trecho" class="trecho">({{ midia.observacoes }})</p></td>
                                    <td class="text-center"><p v-if="midia.legendas">{{midia.legendas}}</p></td>
                                    <td v-if="titulo.seriado" class="text-center"><p v-if="midia.temporada">{{midia.temporada}}&#170; temporada</p></td>
                                    <td v-if="titulo.seriado" class="text-center"><p>{{ !midia.discos ? '1' : midia.discos }}</p></td>
                                    <td class="text-right"><p><strong>{{midia.data_cadastro}}</strong></p></td>
                                </tr>
                                <tr v-if="midia.episodios && midia.episodios.length > 0" :key="`${midia.id}-episodio-list`" :class="[midia.preco ? 'gold' : '']">
                                    <td colspan="8">
                                    <div class="episodios">
                                        <strong>Episódios presentes na mídia:</strong>
                                        <p v-for="episodio in midia.episodios" :key="episodio.id" :title="episodioFormat(episodio)">
                                        {{episodioFormat(episodio)}}
                                        </p>
                                    </div>
                                    </td>
                                </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Ações da Sacola de Títulos" v-if="person.filmografia.length">
                        <div class="btn-group my-2" role="group" aria-label="First group">
                            <b-form-checkbox v-model="allSelected" @change="toggleAll" name="check-button" button button-variant="secondary" size="sm">
                            {{ allSelected ? 'Desmarcar Todas' : 'Marcas Todas' }}
                            </b-form-checkbox>
                        </div>
                        <div class="btn-group my-2" role="group" aria-label="First group">
                            <base-button type="primary" size="sm" class="d-inline-block float-right" :disabled="!selected.length" @click="addToCart(selected)">
                                Adicionar
                            </base-button>
                        </div>
                    </div>
                </v-wait>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: 'personMidias',
  components: {
  	SlideYUpTransition
  },
  computed: {
    person() {
      return this.$store.state.catalog.person;
    },
    ...mapGetters('cart', [
      'sacolaCheia',
    ]),
  },
  data() {
    return {
      selected: [],
      allSelected: false,
      modal: {
        title: '', 
        body: '', 
        classe: '', 
        icon: 'ni ni-basket', 
        okButton: 'OK'
      },
    }
  },
  methods: {
  	...mapActions('cart', [
      'addMedia',
    ]),
    makeRoute(titulo) {
      if ( titulo.seriado ) {
        return '/seriados/'+titulo.id+'/'+titulo.slug+'-'+titulo.ano
      }else {
        return '/filmes/'+titulo.id+'/'+titulo.slug+'-'+titulo.ano
      }
    },
    makeCover(titulo) {
      return this.axios.defaults.baseURL + titulo.capa
    },
    episodioFormat(episodio) {
      let episodioString = '';
      if ( episodio.temporada ) {
        episodioString += episodio.temporada+'x';
      }
      if ( episodio.episodio ) {
        episodioString += episodio.episodio+' - ';
      }
      episodioString += episodio.titulo_traduzido+ ' ('+episodio.ano+')';
      episodioString += ' - '+ episodio.duracao +'min';
      return episodioString;
    },
    toggleAll(checked) {
      this.selected = checked ? this.sacolaTitulos.slice() : []
    },
    updateModalInfo(data) {
      this.modal.title = data.title;
      this.modal.body = data.body;
      this.modal.classe = data.classe;
      this.$store.dispatch('modal/invokeStateModal', this.modal);
    },
    addToCart(selected) {
      if ( this.sacolaCheia == true ) {
        let modalObject = {
          title: 'Carrinho Cheio!',
          body: 'Seu carrinho atingiu o limite de mídias por pedido',
          classe: 'modal-warning'
        };
        this.updateModalInfo(modalObject);
      }else {
        this.addMedia(selected).then((response) => {
          if ( this.$store.state.cart.add_media_complete == true ) {
            if ( this.$store.state.cart.cart_item_exists == true ) {
              let modalObject = {
                title: 'Sacola de Títulos',
                body: 'A mídia já existe na sua Sacola de Títulos',
                classe: 'modal-info'
              };
              this.updateModalInfo(modalObject);
            }else {
              let modalObject = {
                title: 'Sacola de Títulos Atualizada!',
                body: 'Você incluiu novas mídias em sua Sacola de Títulos',
                classe: 'modal-success'
              };
              this.updateModalInfo(modalObject);
            }
          }
        });
      }
    }
  },
};
</script>
<style lang="scss" scoped>
  div.episodios {
    font-size: 0.8em;
    p {
      display: block;
      clear: both;
      margin-bottom: 5px;
    }

  }
  .cart-table {
    thead {
      th {
        border-bottom: 0;
        font-size: 0.8em;
        vertical-align: middle;
        &.format {
          width: 15%;
        }
        &.titleName {
          font-size: 1.1em;
        }
      }
    }
    tbody {
      td {
        p {
          font-size: 0.9em;
          margin-bottom: 0;
          strong {
            font-weight: 700;
          }
          &.trecho {
            font-size: 0.75em;
            line-height: 1;
          }
        }
      }
    }
  }
</style>
